export class GlobalConstants {
    static IS_IRIS_UI_VISIBLE = true;
    static IS_ROUTE_DETAILS_LOADING = false;
    static SELECTED_PANEL = "";
    static PALLETS_AT_DC = "PALLETS_AT_DC";
    static PALLETS_AT_STORE = "PALLETS_AT_STORE";
    static PALLETS_AT_LOST = "PALLETS_AT_LOST";

    static addressList = [];
    static SELECT_DB_ROUTES = [];
    static SELETED_ROUTE_INDEX = 0;
    static NAVIGATE_ROUTE_DETAILS = false

    static addAddress = (address,lat,lng) => {
        GlobalConstants.addressList.push({lat:lat,lng:lng,address:address});
    }

    static getAddress(lat,lng) {
        for(let i=0; i<GlobalConstants.addressList.length;i++){
            let addressItem = GlobalConstants.addressList[i];
            if(addressItem.lat == lat && addressItem.lng == lng){
                return addressItem.address;
            }

        }
        return ""
    }
    static IS_WEB_PROCESS = true;
    static CUSTOMER_DATA = null;
    static LOCATION_DATA = null;
}
